import { render, staticRenderFns } from "./promotion-banner.vue?vue&type=template&id=7a366938&"
import script from "./promotion-banner.vue?vue&type=script&lang=js&"
export * from "./promotion-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports